import React from 'react';
import { Skeleton } from '../../ui';

/**
 * The step's first read, shaped like what it will become: the thread list
 * beside a conversation. A data load is not Robbie working, so no mascot.
 */
const ThreadRowSkeleton: React.FC = () => (
  <div className="flex flex-col gap-s2 border-b border-line-divider-soft px-s4 py-s4">
    <Skeleton width="55%" />
    <Skeleton width="80%" />
    <Skeleton width="40%" height={8} />
  </div>
);

const OutreachLoading: React.FC = () => (
  <div
    role="status"
    aria-busy="true"
    aria-label="Loading your supplier threads"
    className="grid min-h-[440px] grid-cols-[minmax(150px,268px)_minmax(0,1fr)] overflow-hidden rounded-card border border-line bg-surface max-md:grid-cols-1"
  >
    <div className="border-r border-line max-md:border-r-0">
      <ThreadRowSkeleton />
      <ThreadRowSkeleton />
      <ThreadRowSkeleton />
    </div>
    <div className="flex flex-col gap-s4 p-s5 max-md:hidden">
      <Skeleton width="35%" height={14} />
      <Skeleton shape="bubble" width="60%" />
      <Skeleton shape="bubble" width="45%" className="self-end" />
      <Skeleton shape="bubble" width="55%" />
    </div>
  </div>
);

export default OutreachLoading;
